export default Object.freeze({
  list: [],
  options: [],
  info: {},
});
